/* eslint-disable */
import React, { useState, useEffect } from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Grid,
  TextField,
  IconButton,
  Typography,
  CircularProgress,
} from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import CloseIcon from '@material-ui/icons/Close';
import RoomIcon from '@material-ui/icons/Room';
import MyButton from '../../../components/button/MyButton';
import api from '../../../service/axios/api';

const useStyles = makeStyles((theme) => ({
  dialogTitle: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    paddingBottom: theme.spacing(1),
    borderBottom: '1px solid #e0e0e0',
  },
  titleContent: {
    display: 'flex',
    alignItems: 'center',
    gap: theme.spacing(1),
  },
  titleIcon: {
    color: '#FF8C00',
    fontSize: 28,
  },
  titleText: {
    fontWeight: 600,
    fontSize: '1.1rem',
    color: '#333',
  },
  subtitleText: {
    fontSize: '0.8rem',
    color: '#888',
    marginTop: 2,
  },
  dialogContent: {
    paddingTop: theme.spacing(2),
    paddingBottom: theme.spacing(1),
  },
  sectionLabel: {
    fontSize: '0.75rem',
    fontWeight: 600,
    color: '#888',
    textTransform: 'uppercase',
    letterSpacing: '0.08em',
    marginBottom: theme.spacing(1),
    marginTop: theme.spacing(2),
  },
  textField: {
    '& .MuiOutlinedInput-root': {
      borderRadius: 8,
      '&:hover fieldset': {
        borderColor: '#FF8C00',
      },
      '&.Mui-focused fieldset': {
        borderColor: '#FF8C00',
      },
    },
    '& label.Mui-focused': {
      color: '#FF8C00',
    },
  },
  dialogActions: {
    padding: theme.spacing(2, 3),
    borderTop: '1px solid #e0e0e0',
    gap: theme.spacing(1),
  },
  requiredNote: {
    fontSize: '0.75rem',
    color: '#aaa',
    marginTop: theme.spacing(1),
  },
}));

export default function EditAddressModal({
  open,
  onClose,
  individual,
  idCai,
  onSuccess,
  notifySuccess,
  notifyError,
}) {
  const classes = useStyles();
  const [saving, setSaving] = useState(false);

  const emptyAddress = {
    postal_code: '',
    street_name: '',
    number: '',
    complement: '',
    district: '',
    city: '',
    state: '',
    care_of: '',
  };

  const [form, setForm] = useState(emptyAddress);
  const [errors, setErrors] = useState({});


  useEffect(() => {
    if (individual) {
      setForm({
        postal_code:   individual.postal_code   || '',
        street_name: individual.street_name || '',
        number:      individual.number      || '',
        complement:  individual.complement  || '',
        district:    individual.district    || '',
        city:        individual.city        || '',
        state:       individual.state       || '',
        care_of:     individual.care_of     || '',
      });
      setErrors({});
    }
  }, [individual]);

  const handleChange = (field) => (e) => {
    setForm((prev) => ({ ...prev, [field]: e.target.value }));
    if (errors[field]) {
      setErrors((prev) => ({ ...prev, [field]: undefined }));
    }
  };

  const handleClear = () => {
    setForm(emptyAddress);
    setErrors({});
  };

 const handleSave = async () => {
  setSaving(true);
  try {
    await api.contract.editAddressCAI(idCai, form);
    notifySuccess('Endereço atualizado com sucesso!');
    onSuccess?.();
    onClose();
  } catch (error) {
    console.error(error);
    notifyError(error.message || 'Erro ao atualizar endereço.');
  } finally {
    setSaving(false);
  }
};


  const handleClose = () => {
    if (!saving) onClose();
  };

  const fixedLabel = { shrink: true };

  return (
    <Dialog
      open={open}
      onClose={handleClose}
      maxWidth="sm"
      fullWidth
      PaperProps={{ style: { borderRadius: 12 } }}
    >

      <DialogTitle disableTypography className={classes.dialogTitle}>
        <div className={classes.titleContent}>
          <RoomIcon className={classes.titleIcon} />
          <div>
            <Typography className={classes.titleText}>Editar Endereço</Typography>
            {individual && (
              <Typography className={classes.subtitleText}>
                {individual.name || individual.doc}
              </Typography>
            )}
          </div>
        </div>
        <IconButton size="small" onClick={handleClose} disabled={saving}>
          <CloseIcon fontSize="small" />
        </IconButton>
      </DialogTitle>

      <DialogContent className={classes.dialogContent}>
        <Grid container spacing={2}>

          <Grid item xs={12} sm={4}>
            <TextField
              label="CEP *"
              variant="outlined"
              fullWidth
              size="small"
              value={form.postal_code}
              onChange={handleChange('postal_code')}
              error={!!errors.postal_code}
              helperText={errors.postal_code}
              className={classes.textField}
              inputProps={{ maxLength: 8 }}
              InputLabelProps={fixedLabel}
            />
          </Grid>

          <Grid item xs={12} sm={8}>
            <TextField
              label="Logradouro *"
              variant="outlined"
              fullWidth
              size="small"
              value={form.street_name}
              onChange={handleChange('street_name')}
              error={!!errors.street_name}
              helperText={errors.street_name}
              className={classes.textField}
              InputLabelProps={fixedLabel}
            />
          </Grid>

          <Grid item xs={12} sm={3}>
            <TextField
              label="Número *"
              variant="outlined"
              fullWidth
              size="small"
              value={form.number}
              onChange={handleChange('number')}
              error={!!errors.number}
              helperText={errors.number}
              className={classes.textField}
              InputLabelProps={fixedLabel}
            />
          </Grid>

          <Grid item xs={12} sm={9}>
            <TextField
              label="Complemento"
              variant="outlined"
              fullWidth
              size="small"
              value={form.complement}
              onChange={handleChange('complement')}
              className={classes.textField}
              placeholder="Apto, Bloco, Sala…"
              InputLabelProps={fixedLabel}
            />
          </Grid>

          <Grid item xs={12} sm={6}>
            <TextField
              label="Bairro *"
              variant="outlined"
              fullWidth
              size="small"
              value={form.district}
              onChange={handleChange('district')}
              error={!!errors.district}
              helperText={errors.district}
              className={classes.textField}
              InputLabelProps={fixedLabel}
            />
          </Grid>

          <Grid item xs={12} sm={4}>
            <TextField
              label="Cidade *"
              variant="outlined"
              fullWidth
              size="small"
              value={form.city}
              onChange={handleChange('city')}
              error={!!errors.city}
              helperText={errors.city}
              className={classes.textField}
              InputLabelProps={fixedLabel}
            />
          </Grid>

          <Grid item xs={12} sm={2}>
            <TextField
              label="UF *"
              variant="outlined"
              fullWidth
              size="small"
              value={form.state}
              onChange={handleChange('state')}
              error={!!errors.state}
              helperText={errors.state}
              className={classes.textField}
              inputProps={{ maxLength: 2, style: { textTransform: 'uppercase' } }}
              InputLabelProps={fixedLabel}
            />
          </Grid>

          <Grid item xs={12}>
            <TextField
              label="Aos cuidados de"
              variant="outlined"
              fullWidth
              size="small"
              value={form.care_of}
              onChange={handleChange('care_of')}
              className={classes.textField}
              InputLabelProps={fixedLabel}
            />
          </Grid>
        </Grid>
      </DialogContent>

      <DialogActions className={classes.dialogActions}>
        <MyButton
          onClick={handleClose}
          disabled={saving}
          variant="outlined"
          label="Cancelar"
        />
        <MyButton
          onClick={handleClear}
          disabled={saving}
          variant="outlined"
          label="Limpar"
        />
        <MyButton
          onClick={handleSave}
          disabled={saving}
          label={saving ? 'Salvando…' : 'Salvar'}
          startIcon={saving ? <CircularProgress size={14} color="inherit" /> : null}
        />
      </DialogActions>
    </Dialog>
  );
}